module.exports = __webpack_public_path__ + "img/block.45fe18a5.svg";